import { render, staticRenderFns } from "./not-found.vue?vue&type=template&id=673e198c&scoped=true&lang=pug"
import script from "./not-found.vue?vue&type=script&lang=js"
export * from "./not-found.vue?vue&type=script&lang=js"
import style0 from "./not-found.vue?vue&type=style&index=0&id=673e198c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673e198c",
  null
  
)

export default component.exports